import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { select, Store } from "@ngrx/store";
import { of } from "rxjs";
import {
  catchError,
  distinctUntilKeyChanged,
  filter,
  map,
  switchMap,
} from "rxjs/operators";
import { selectSelectedActivity } from "src/app/levels/components/level/store/selectors";
import { CodeAdventureActivitiesService } from "src/app/services";
import { AppStoreState } from "src/app/store";
import * as FeatureActions from "./actions";
import { updateLevelStatus } from "src/app/levels/components/level/store/actions";

@Injectable()
export class Effects {
  constructor(
    private actions$: Actions,
    private store$: Store<AppStoreState>,
    private service: CodeAdventureActivitiesService
  ) {}

  triggerLoadActivity$ = createEffect(() =>
    this.store$.pipe(
      select(selectSelectedActivity),
      filter((a) => !!a && a.type === "Adventure"),
      distinctUntilKeyChanged("id"),
      map(({ id: activityId }) =>
        FeatureActions.loadCodeAdventureActivity({ activityId })
      )
    )
  );

  loadCodeAdventureActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FeatureActions.loadCodeAdventureActivity),
      switchMap(({ activityId }) =>
        this.service.getCodeAdventureActivityById(activityId).pipe(
          map((activity) =>
            FeatureActions.loadCodeAdventureActivitySuccess({ activity })
          ),
          catchError((error) =>
            of(FeatureActions.loadCodeAdventureActivityFailure({ error }))
          )
        )
      )
    )
  );

  updateCodeAdventureActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FeatureActions.updateActivity),
      switchMap(({ activity, mediaFile }) =>
        this.service.updateCodeAdventureActivity(activity, mediaFile).pipe(
          map((mediaFile) =>
            FeatureActions.updateActivitySuccess({ activity, mediaFile })
          ),
          catchError((error) =>
            of(FeatureActions.updateActivityFailure({ error }))
          )
        )
      )
    )
  );

  updateSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FeatureActions.updateActivitySuccess),
      map((_) => {
        return updateLevelStatus({
          status: "draft",
        });
      })
    )
  );
}
